import { Component } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router, RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { LoadingScreenService } from './shared/services/loading-screen/loading-screen.service';
import { LoadingScreenComponent } from "./shared/services/loading-screen/loading-screen.component";

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet, LoadingScreenComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'customer-form';

  constructor(
    private router: Router,
    public loadingScreenService: LoadingScreenService
    
  )
  {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.loadingScreenService.show();
      } else if (
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel ||
        event instanceof NavigationError
      ) {
        this.loadingScreenService.hide();
      }
    });
  }
}
